<main class="homeMain" id="homeMain">
  <header class="headerHome" id="headerHome">
    <img src="assets/img/imagen-approbe2.svg" alt="" />
  </header>
  <body class="bodyMain" id="bodyMain">
    <div class="titleBodyMain" id="titleBodyMain">
      <h1>¡Compra ahora, paga después con Approbe!</h1>
      <h2>Solicita tu cupo digital en menos de 5 minutos.</h2>
    </div>
    <div class="contentBodyMain" id="contentBodyMain">
      <div class="contentItemBodyMain" id="contentItemBodyMain1">
        <img src="assets/img/homeImage1.svg" alt="" />
        <h1>Sin papeleos, Sin complicaciones.</h1>
      </div>
      <div class="contentItemBodyMain" id="contentItemBodyMain2">
        <img src="assets/img/homeImage2.svg" alt="" />
        <h1>Tu información está segura.</h1>
      </div>
    </div>
    <div class="AuthorizationBodyMain" id="AuthorizationBodyMain">
      <div
        class="contentAuthorizationBodyMain"
        id="contentAuthorizationBodyMain"
      >
        <input type="checkbox" [(ngModel)]="authorizationCheck" />
        <p>
          Autorizo a Approbe SAS a tratar tus datos personales conforme a
          nuestra
          <a href="https://www.approbe.co/inicio/politicas-privacidad"
            >Política de Privacidad</a
          >, de acuerdo con la Ley 1581 de 2012 y la Ley 1266 de 2008. También
          autorizas la consulta a tu historial crediticio ante operadores de
          información, así como la verificación en listas restrictivas
          nacionales e internacionales (como OFAC, ONU, INTERPOL u otras
          aplicables), requisito esencial para validar tu perfil de riesgo y
          brindarte un cupo con responsabilidad.
        </p>
      </div>
    </div>
    <button
      class="btnBodyMain"
      [disabled]="!authorizationCheck"
      (click)="handleNextStep()"
    >
      Solicitar mi cupo
    </button>
  </body>
  <footer class="footerMain" id="footerMain">
    <div class="footerMainSection" id="footerMainSection1">
      <div class="footerMainSectionContent" id="footerMainSectionContent1">
        <h1>Nit:</h1>
        <h2>9014990365</h2>
      </div>
      <div class="footerMainSectionContent" id="footerMainSectionContent2">
        <h1>Contacto:</h1>
        <a>3164740252</a>
      </div>
      <div class="footerMainSectionContent" id="footerMainSectionContent3">
        <a>info&#64;approbe.co</a>
      </div>
    </div>
    <div class="footerMainSection" id="footerMainSection2">
      <h1>Legal</h1>
      <ul>
        <li>
          <a
            class="list-style"
            target="_blank"
            href="https://www.approbe.co/inicio/politicas-privacidad"
            >Políticas de privacidad</a
          >
        </li>
        <li>
          <a
            class="list-style"
            target="_blank"
            href="https://www.approbe.co/inicio/tyc"
            >Términos y condiciones</a
          >
        </li>
      </ul>
    </div>
    <div class="footerMainSection" id="footerMainSection3">
      <h1>Empresas</h1>
      <ul>
        <li>
          <a class="list-style" target="_blank" [href]="urlCostsAndRates"
            >Costos y Tarifas</a
          >
        </li>
        <li>
          <a
            class="list-style"
            target="_blank"
            href="https://share.hsforms.com/1-as5_7SgT2aGobiGBMz5WAqmg8h"
            >Buzón de PQR</a
          >
        </li>
      </ul>
    </div>
  </footer>
</main>
